import { z } from 'zod';

import {
    allowEmptyString,
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createProcedureAddSchema = () =>
    z
        .object({
            id: requiredString,
            user_id: requiredString,
            organisation_id: allowEmptyString,
            category: z.enum(['shoe', 'trim', 'other']),
            name: requiredString,
            description: optionalString,
            price: requiredString,
            available: z.boolean(),
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createProcedureUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createProcedureAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.procedures,
    );

export const createProcedureDeleteSchema = () => createDeleteSchema();

export const createProcedureSchemas = () => ({
    add: createProcedureAddSchema(),
    update: createProcedureUpdateSchema(),
    delete: createProcedureDeleteSchema(),
});

export const procedureRawRecordSchema = createProcedureAddSchema();
